import { DeleteOutline } from '@mui/icons-material';
import { Box, Button, CircularProgress, Divider, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { arrayRemove, doc, setDoc } from 'firebase/firestore';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SocialIcon } from 'react-social-icons';
import { socialLinks } from '../../common/utils';
import { Social } from '../../consts/types/user';
import { db } from '../../firebase';
import { UserSelectors, userActionsCreators } from '../../reducers/user';
import ItemMenu from '../Common/ItemMenu';
import AddSocialDialog from './Dialogs/AddSocialDialog';
const { NotificationManager } = require('react-notifications');

interface SocialProps {

}

type Props = SocialProps;


const UserSocial: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);
    const [social, setSocial] = useState(user?.social || []);
    const [isSaving, setIsSaving] = useState(false);
    const [isAddingSocial, setIsAddingSocial] = useState(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const dispatch = useDispatch();



    const removeSocial = (so: Social) => () => {
        if (user?.email) {
            const updatedSocials = social.filter(r => r.link !== so.link);
            setIsSaving(true);
            if (user) {
                dispatch(userActionsCreators.setUser({ user: { ...user, social: updatedSocials } }));
            }
            setDoc(doc(db, "users", user.email), {
                social: arrayRemove(so),
            }, { merge: true })
                .then((result) => {
                    setIsSaving(false);
                    NotificationManager.success('Changes were saved successfully!',);
                })
                .catch(() => {
                    setIsSaving(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
    }

    return <Box display="flex" flexDirection="column"  flex={1} gap={4} >
        {/* {isStepNotComplete(UserProfileStep.SocialAccounts) && <Alert severity='warning' sx={{ display: { xs: "flex", md: "none" } }}>Step is not completed yet</Alert>} */}
        {/* <Typography fontSize="0.875rem" color="text.secondary">Social account links such as LinkedIn, Stackoverflow etc.</Typography> */}
        <Card variant="outlined">
            <CardContent>
                <Box borderRadius="4px" sx={{ overflowY: "auto" }} >
                    <Box display="flex" justifyContent="space-between" alignItems="center" >
                        <Box display="flex" alignItems="center">
                            <Typography color="primary" fontWeight={500}>SOCIAL LINKS</Typography>
                            {isSaving && <CircularProgress sx={{ width: "18px  !important", height: "18px !important", ml: 1 }} />}
                        </Box>
                        <Button variant="outlined" size="small" onClick={() => { setIsAddingSocial(true) }}>+ Add </Button>
                    </Box>

                    {social?.map((so, index, arr) => <Card key={so.link} sx={{ mt: 1, border: "none" }} variant="outlined" >
                        <CardContent sx={{ paddingBottom: "0 !important"}}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Link color="primary" href={so.link} rel="noreferrer"
                                    fontWeight={400}
                                    target="_blank"
                                    textTransform="capitalize"
                                    display="flex"
                                    alignItems="center"
                                    fontSize={{ xs: "1rem", md: "1.1rem" }} >
                                    <SocialIcon url={so.link} style={{ marginRight: "5px", height: 26, width: 26 }} />
                                    {socialLinks.detectProfile(so.link)}
                                </Link>
                                <Box display="flex">
                                    <ItemMenu items={[{
                                        label: "Delete",
                                        icon: <DeleteOutline fontSize='small' color="inherit" />,
                                        onClick: removeSocial(so)
                                    }]} />
                                </Box>
                            </Box>

                            {/* <Typography mt={1} fontWeight={500} color={getFieldStatusColor(so.status,)} fontSize={{ xs: "0.7rem", md: "0.875rem" }}>
                        {so.status}
                    </Typography> */}
                            {index < arr.length - 1 && <Divider sx={{ mt: 2 }} />}
                        </CardContent>
                    </Card>)}
                </Box>
            </CardContent>
        </Card>
        <AddSocialDialog isAddingSocial={isAddingSocial}
            isSavingSocial={isSaving}
            setIsAddingSocial={setIsAddingSocial}
            setIsSavingSocial={setIsSaving} />
    </Box>;
}


export default UserSocial;

